import { render, staticRenderFns } from "./workflow_core.vue?vue&type=template&id=89a4309c&scoped=true&"
import script from "./workflow_core.vue?vue&type=script&lang=js&"
export * from "./workflow_core.vue?vue&type=script&lang=js&"
import style0 from "./workflow_core.vue?vue&type=style&index=0&id=89a4309c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a4309c",
  null
  
)

/* custom blocks */
import block0 from "./workflow_core.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports